export default __webpack_public_path__ + "static/media/webIcon.737bb694.svg";